import {
  Button,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  SimpleSelect,
} from '@kalos/ui';
import { useMemo } from 'react';

import { OPTION_ALL } from '../../../constants';
import { REIMBURSEMENT_STATUSES } from './constants';
import { useReimbursementSearchFormContext } from './ReimbursementSearchForm.hooks';
import {
  getDefaultReimbursementSearchFormValues,
  getReimbursementWeekOptions,
} from './reimbursementSearchFormValues';
import { ReimbursementStatusLabel } from './ReimbursementStatusesLabel';

const reimbursementStatusesSelectOptions: React.ComponentProps<typeof SimpleSelect>['values'] =
  REIMBURSEMENT_STATUSES.map((status) => ({
    label: <ReimbursementStatusLabel id={status.value} />,
    value: status.value.toString(),
  }));

export const ReimbursementSearchForm = () => {
  const form = useReimbursementSearchFormContext();

  const WEEK_OPTIONS = useMemo(() => getReimbursementWeekOptions(), []);

  const handleReset = () => {
    form.reset(getDefaultReimbursementSearchFormValues());
  };

  return (
    <div>
      <form className="grid grid-cols-1 gap-4 sm:grid-cols-3" onSubmit={console.log}>
        <FormField
          control={form.control}
          name="description"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Search Reimbursables</FormLabel>
              <FormMessage />
              <FormControl>
                <Input {...field} />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="createdDate"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Week</FormLabel>
              <FormMessage />
              <FormControl>
                <SimpleSelect
                  values={WEEK_OPTIONS}
                  onChange={field.onChange}
                  placeholder={OPTION_ALL}
                  selectedValue={field.value}
                  disabled={field.disabled}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="statusId"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Status</FormLabel>
              <FormMessage />
              <FormControl>
                <SimpleSelect
                  values={reimbursementStatusesSelectOptions}
                  onChange={field.onChange}
                  placeholder={OPTION_ALL}
                  selectedValue={field.value.toString()}
                  disabled={field.disabled}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </form>
      <div className="mt-4 flex justify-end">
        <Button onClick={handleReset}>Reset</Button>
      </div>
    </div>
  );
};

ReimbursementSearchForm.getDefaultValues = getDefaultReimbursementSearchFormValues;
